import React from "react"
import styled from "styled-components"

const Contact = () => {
  return (
    <ContactContainer id="contact">
      <h1>Contact Me</h1>
      <Form>
        <Section>
          <label htmlFor="Username">Name:</label>
          <input type="text" placeholder="e.g Imran Sayed" required />
        </Section>
        <Section>
          <label htmlFor="Email">Email:</label>
          <input type="email" placeholder="e.g Email@gmail.com" required />
        </Section>
        <Section>
          <label htmlFor="Subject">Subject:</label>
          <input
            type="text"
            placeholder="e.g Need an App for my Business"
            required
          />
        </Section>
        <Section>
          <label htmlFor="Message">Message:</label>
          <textarea
            placeholder="e.g App where I can track all the progress of my business and get insights of products and expenses"
            required
          />
        </Section>
        <ContactButton type="submit">SUBMIT</ContactButton>
      </Form>
    </ContactContainer>
  )
}

const ContactButton = styled.button`
  font-size: 1.5rem;
  border: none;
  outline: none;
  border-radius: 5px;
  font-weight: 500;
  padding: 8px 20px;
  margin: 5px 0;
  background-color: #e94e1b;
  letter-spacing: 1px;
  color: #fff;
  cursor: pointer;

  @media screen and (max-width: 475px) {
    font-size: 1.2rem;
  }
`

const ContactContainer = styled.section`
  width: 500px;
  max-width: 94%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 1;

  h1 {
    text-align: center;
  }

  @media screen and (max-width: 768px) {
    width: 400px;
  }

  @media screen and (max-width: 475px) {
    max-width: 90%;
  }
`
const Form = styled.form`
  display: flex;
  flex-direction: column;
  padding: 0 0 1rem 0;
`

const Section = styled.section`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  label {
    font-size: 1.3rem;
  }

  input,
  textarea {
    height: 1.5rem;
    margin-top: 5px;
    border: 2px solid #011627;
    outline: none;
    border-radius: 5px;
    font-size: 1rem;
    padding: 5px 0 5px 10px;
    background-color: #dae0e2;
  }

  input:hover,
  input:focus,
  textarea:hover,
  textarea:focus {
    border: 2px solid #e94e1b;
  }

  textarea {
    height: 4rem;
    padding-top: 10px;
  }

  @media screen and (max-width: 475px) {
    input {
      height: 1.5rem;
    }
    textarea {
      height: 3rem;
    }
  }
`

export default Contact
